import { createAction } from 'redux-actions';

export const updateAuditLogsSearchQuery = createAction(
  'UPDATE_INVENTORY_AUDIT_LOGS_SEARCH_QUERY'
);

export const resetAuditLogsSearchQuery = createAction(
  'RESET_INVENTORY_AUDIT_LOGS_SEARCH_QUERY'
);
